/**
 * Used as a base for any state
 */
class MobxState {
  constructor(root) {
    this.root = root;
    this.reactions_ = [];
  }

  /**
   * Used mostly to initialize reactions.
   * As we are extending this class,
   * we need a way to create every it "observable" (apply annotations) first
   * and only after apply all the reactions if needed/if presented
   */
  init() {}

  destroy() {
    this.reactions_.forEach((r) => r());
  }
}

MobxState.annotations = {};

export default MobxState;
